import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/routes/app-routes';
import { MustMatch } from '@shared/validator';
import {
  AwsService,
  HelperService,
  TranslateService,
  UserProfileService,
} from '__services';
import { Subject } from 'rxjs';
import { ProfileApi } from '~/app/common/api/profile.api';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss', '../login/login.component.scss'],
})
export class NewPasswordComponent implements OnInit, OnDestroy {
  hide = true;
  isLoading = false;
  setPasswordForm: FormGroup;
  user: any;
  errorMsg = '';
  private destroy$: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private awsService: AwsService,
    private userProfileService: UserProfileService,
    private trans: TranslateService,
    private profileApi: ProfileApi,
  ) {
    this.setPasswordForm = this.fb.group(
      {
        password: ['', [Validators.required]],
        confirmPassword: [''],
      },
      {
        validators: MustMatch('password', 'confirmPassword'),
      },
    );
  }

  get formControl(): any {
    return this.setPasswordForm.controls;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  setPassword(): void {
    this.setPasswordForm.markAllAsTouched();
    if (this.setPasswordForm.valid && !this.isLoading) {
      this.isLoading = true;
      this.awsService
        .confirmSignIn(this.formControl.password.value)
        .then(async () => {
          try {
            const session = await this.awsService.fetchAuthSession();
            const accessToken = session?.tokens?.accessToken?.toString();

            if (!accessToken) {
              throw new Error('Access token not found after setting password');
            }

            this.profileApi.activateUser(accessToken).subscribe({
              next: () => {
                this.callLoginAndNavigate();
              },
              error: (err) => {
                this.isLoading = false;
                this.errorMsg =
                  err?.error?.error?.message ??
                  err?.message ??
                  'Activate user failed';
              },
            });
          } catch (err: any) {
            this.isLoading = false;
            this.errorMsg = err.message;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.errorMsg = err.message;
        });
    }
  }

  private callLoginAndNavigate(): void {
    this.awsService.callLogin().subscribe(
      (res) => {
        this.errorMsg = '';
        this.userProfileService.setUserFeature(res.role.modules);
        this.userProfileService.setUserProfile(res);
        this.router.navigate([APP_ROUTES.DASHBOARD], {
          replaceUrl: true,
        });
      },
      (err) => {
        this.isLoading = false;
        this.errorMsg = err.message;
        this.router.navigate([APP_ROUTES.DASHBOARD], {
          replaceUrl: true,
        });
      },
    );
  }

  getPasswordErrorMessage(): string | undefined {
    if (this.formControl.password.hasError('required')) {
      return this.trans.translate('You must enter a value');
    }
  }

  getConfirmPasswordErrorMessage(): string | undefined {
    if (this.formControl.confirmPassword.hasError('required')) {
      return this.trans.translate('You must enter a value');
    }
    if (
      this.formControl.password.value !== this.formControl.confirmPassword.value
    ) {
      return this.trans.translate('Confirm password not match');
    }
  }

  getToday(): string {
    return HelperService.getToday();
  }
}
